import BaseModel from "../base_model.js";

import { InputLabelDisplayModeAbove } from "../../base/inputs/constants.js";

import LoadCountriesUseCase from "../../use_cases/addresses/countries/list_countries_use_case.js";
class RawProfileAddressModel extends BaseModel {

  rawNestedFormFields(item = undefined) {
    return [
      {
        name: "street",
        displayName: this.fieldDisplayName("street"),
        type: "text",
        weight: 9,
        displayNamePosition: InputLabelDisplayModeAbove
      },
      {
        name: "number",
        displayName: this.fieldDisplayName("number"),
        type: "text",
        weight: 3,
        displayNamePosition: InputLabelDisplayModeAbove
      },
      {
        name: "additionToAddress",
        displayName: this.fieldDisplayName("additionToAddress"),
        type: "text",
        weight: 12,
        displayNamePosition: InputLabelDisplayModeAbove
      },
      {
        name: "postalCode",
        displayName: this.fieldDisplayName("postalCode"),
        type: "text",
        weight: 4,
        displayNamePosition: InputLabelDisplayModeAbove
      },
      {
        name: "city",
        displayName: this.fieldDisplayName("city"),
        type: "text",
        weight: 4,
        displayNamePosition: InputLabelDisplayModeAbove
      },
      {
        name: "country",
        displayName: this.fieldDisplayName("country"),
        type: "model",
        useCase: LoadCountriesUseCase,
        foreignKey: "countryId",
        weight: 4,
        displayNamePosition: InputLabelDisplayModeAbove
      },
    ]
  }

  i18nScope() {
    return "model.addresses.address";
  }

}
const ProfileAddressModel = new RawProfileAddressModel();

export { RawProfileAddressModel, ProfileAddressModel }
